var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 13,
    viewBox: "0 0 9 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.24609 6.14844L6.49609 0.898438C6.82422 0.542969 7.39844 0.542969 7.72656 0.898438C8.08203 1.22656 8.08203 1.80078 7.72656 2.12891L3.10547 6.75L7.72656 11.3984C8.08203 11.7266 8.08203 12.3008 7.72656 12.6289C7.39844 12.9844 6.82422 12.9844 6.49609 12.6289L1.24609 7.37891C0.890625 7.05078 0.890625 6.47656 1.24609 6.14844Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowLeft);
export default __webpack_public_path__ + "static/media/icon_arrow_left.206a1305326ed6e9a74563fa2096c708.svg";
export { ForwardRef as ReactComponent };